import { createApp } from 'vue';
import DngToPngConverter from '../Components/DngToPngConverter.vue';

const root = document.getElementById('dng-to-png-converter');
if (root) {
  createApp(DngToPngConverter).mount('#dng-to-png-converter');
}
